import { radioAnatomy as parts } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';
import { ThemeBorderToken, ThemeColorToken, ThemeFontSizeToken, ThemeFontToken, } from '../theme-tokens';
/**
 * GENERAL FILE NOTE: Hover styles for Radio are defined in the Component itself.
 * @see radio.hoverstyles.ts.
 */
const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts.keys);
const dotStyle = {
    content: `""`,
    display: 'inline-block',
    pos: 'relative',
    w: '50%',
    h: '50%',
    borderRadius: '50%',
    bg: ThemeColorToken.OnAccent,
};
const baseStyle = {
    label: {
        color: ThemeColorToken.OnSurface,
        fontFamily: ThemeFontToken.Body,
        fontSize: ThemeFontSizeToken.Medium,
        _disabled: {
            opacity: 1,
        },
    },
    control: {
        border: ThemeBorderToken.Small,
        borderColor: ThemeColorToken.OnBackground,
        color: ThemeColorToken.OnAccent,
        bg: 'transparent',
        width: '24px',
        height: '24px',
        minH: '24px',
        minW: '24px',
        _disabled: {
            opacity: 0.48,
            color: ThemeColorToken.OnAccent,
            borderColor: ThemeColorToken.OnBackground,
            bg: 'transparent',
        },
        _checked: {
            bg: ThemeColorToken.Accent,
            borderColor: ThemeColorToken.Accent,
            _before: {
                ...dotStyle,
            },
            _disabled: {
                bg: ThemeColorToken.Accent,
                borderColor: ThemeColorToken.Accent,
                _before: {
                    ...dotStyle,
                },
            },
        },
    },
};
export const radioConfig = defineMultiStyleConfig({
    baseStyle,
});
//# sourceMappingURL=radio-theme.js.map